const LoginImages = {
  leftContentImage: '/static/images/banner.png',
  bgImageColor: null,
  customTagLine: null,
};

export default LoginImages;
